
export const PLAYER_PROFILE_ROUTE = '/my-profile-dashboard';

export const NON_PLAYER_PROFILE_ROUTE = '/my-space/my-profile';
